import React from 'react';

export default function FormatText (isMale, par){

    //if(par.includes('<G>'))
    if(par.indexOf('<G>') > -1){
        const splittedPar = par.split('<G>');

        par = '';

        for(let i=0; i<splittedPar.length; i++){
            let part = splittedPar[i];

            if(isMale) {
                if(i>0){
                    const firstIndex = part.indexOf(" ");                  
                    part = firstIndex === -1 ? "" : part.substring(firstIndex, part.length)
                }
            } else {
                if(i<splittedPar.length-1){
                    const lastIndex = part.lastIndexOf(" ");

                    part = part.substring(0, lastIndex+1);
                }
            }
            par += part;
        }
        
    }
    
    // if(par.indexOf('<HL>') > -1){
    //     return par.split('<HL>').map( (text, i)=>{
    //         return <span key={text + "_" + i} style={{
    //             backgroundColor: i%2 !== 0 ? global.colorTheme.secondaryLight : '',
    //         }}>{text}</span>
    //     });
    // } else {
    //     return par;
    // }

    if(par.indexOf('<BR>') > -1){
        return par.split('<BR>').map( (text, i)=>{
            return <div key={text + "_" + i} style={{marginBottom: 8}}>{highlight(text)}</div>
        });
    } else {
        return highlight(par);
    }

    
}

function highlight(par) {
   if(par.indexOf('<HL>') > -1){
        return par.split('<HL>').map( (text, i)=>{
            return <span key={text + "_" + i} style={{
                backgroundColor: i%2 !== 0 ? global.colorTheme.secondaryLight : '',
            }}>{text}</span>
        });
    } else {
        return par;
    }
}




// WEBPACK FOOTER //
// ./src/Utils/TextFormatter.js